"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusGeneric = void 0;
const utils_1 = require("../../utils");
class EventBusGeneric {
    constructor(eventsMap) {
        this.eventsMap = eventsMap;
        this.id = (0, utils_1.createUUID)();
    }
    getTypes() {
        return Object.keys(this.eventsMap);
    }
}
exports.EventBusGeneric = EventBusGeneric;
//# sourceMappingURL=eventBus.js.map